// Components
import IconContent from '../IconContent/IconContent';

// Helpers
import { utils } from '../../helpers';

// WP react stuff
import { useState, useEffect } from '@wordpress/element';
import {__} from "@wordpress/i18n";

const ConditionContent = ({
    level,
    color,
    newAmount,
    oldAmount,
    labels,
    finalText,
    lineThrough,
    noIcon,
}) => {

    const [content, setContent] = useState(null);

    useEffect(() => {

        let icon;
        let iconColor;
        let label;
        let value;

        switch (level) {
            case 'lower':
                icon = 'arrow-down';
                iconColor = 'green-100';
                label = labels.lower;
                if (oldAmount !== null) {
                    value = lineThrough ? utils.toEuro(newAmount) + ' <span class="text-navy-20 line-through text-base">' + utils.toEuro(oldAmount) + '</span>' : utils.toEuro(oldAmount - newAmount) + ' <span>'+ __("a menos", "df-simulators") +'</span>';
                } else {
                    value = utils.toEuro(newAmount)
                }
                break;
            case 'higher':
                icon = 'arrow-up';
                iconColor = 'red-100';
                label = labels.higher;
                if (oldAmount !== null) {
                    value = lineThrough ? utils.toEuro(newAmount) + ' <span class="text-navy-20 line-through text-base">' + utils.toEuro(oldAmount) + '</span>' : utils.toEuro(newAmount - oldAmount) + ' <span>'+ __("a mais", "df-simulators") +'</span>';
                } else {
                    value = utils.toEuro(newAmount)
                }
                break;
            case 'equal':
                icon = 'equal';
                iconColor = 'yellow-100';
                label = labels.equal;
                value = utils.toEuro(newAmount);
                break;
            default:
                break;
        }

        setContent({
            icon,
            color: iconColor,
            title: finalText.replace('{label}', label),
            value,
        });

    }, [finalText, labels, level, lineThrough, newAmount, oldAmount]);

    return content && <IconContent
        icon={!noIcon && content.icon}
        title={content.title}
        color={color || content.color}
        bigText={content.value}
    />;
};

export default ConditionContent;
